module.exports = __webpack_public_path__ + "static/img/trade-300x300.14286c24.jpg";